var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"management-page-outer-container"},[_c('router-view'),_vm._v(" "),(_vm.$route.name === 'tickets')?_c('tickets-list',{attrs:{"search-from-parent":_vm.search},on:{"update-search":function($event){_vm.search = $event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1634e15e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/Tickets.vue
// module id = null
// module chunks = 